import KAccordion from './components/KAccordion.vue'
import KActionBtn from './components/KActionBtn.vue'
import KAlert from './components/KAlert.vue'
import KAvatar from './components/KAvatar.vue'
import KBadge from './components/KBadge.vue'
import KBreadcrumbs from './components/KBreadcrumbs.vue'
import KBtn from './components/KBtn.vue'
import KCallout from './components/KCallout.vue'
import KCategoryCard from './components/KCategoryCard.vue'
import KCategoryPosCard from './components/KCategoryPosCard.vue'
import KCheckbox from './components/KCheckbox.vue'
import KCircleIcon from './components/KCircleIcon.vue'
import KColourCode from './components/KColourCode.vue'
import KColourLine from './components/KColourLine.vue'
import KColourDot from './components/KColourDot.vue'
import KColourPicker from './components/KColourPicker.vue'
import KCounter from './components/KCounter.vue'
import KCropper from './components/KCropper.vue'
import KDialog from './components/KDialog.vue'
import KDiscountCard from './components/KDiscountCard.vue'
import KDivider from './components/KDivider.vue'
import KDropdown from './components/KDropdown.vue'
import KExportCsv from './components/KExportCsv.vue'
import KExternalLabel from './components/KExternalLabel.vue'
import KIcon from './components/KIcon.vue'
import KIconPicker from './components/KIconPicker.vue'
import KInput from './components/KInput.vue'
import KItemCard from './components/KItemCard.vue'
import KKeypad from './components/KKeypad.vue'
import KMenuCard from './components/KMenuCard/KMenuCard.vue'
import KMenuItem from './components/KMenuItem.vue'
import KPagination from './components/KPagination.vue'
import KPopup from './components/KPopup.vue'
import KQuickAccessCard from './components/KQuickAccessCard.vue'
import KRadio from './components/KRadio.vue'
import KRange from './components/KRange.vue'
import KStatus from './components/KStatus.vue'
import KTab from './components/KTab.vue'
import KTable from './components/KTable.vue'
import KTabPanel from './components/KTabPanel.vue'
import KToast from './components/KToast.vue'
import KToggle from './components/KToggle.vue'
import KTooltip from './components/KTooltip.vue'
import KUploader from './components/KUploader/KUploader.vue'
import KWorkingHours from './components/KWorkingHours.vue'
import KBillButton from './components/KBillButton.vue'
import KCheckoutButton from './components/KCheckoutButton.vue'
import KGlassCard from './components/KGlassCard.vue'
import KItemPosCard from './components/KItemPosCard.vue'
import KPosButton from './components/KPosButton.vue'
import KBasicPopup from './components/KBasicPopup.vue'
import KFileUploader from './components/KFileUploader.vue'
import KMemoLine from './components/KMemoLine.vue'

function install(app) {
  app.component('KBadge', KBadge)
  app.component('KIcon', KIcon)
  app.component('KCheckbox', KCheckbox)
  app.component('KBtn', KBtn)
  app.component('KActionBtn', KActionBtn)
  app.component('KRange', KRange)
  app.component('KToggle', KToggle)
  app.component('KExportCsv', KExportCsv)
  app.component('KAlert', KAlert)
  app.component('KCounter', KCounter)
  app.component('KPopup', KPopup)
  app.component('KCallout', KCallout)
  app.component('KExternalLabel', KExternalLabel)
  app.component('KInput', KInput)
  app.component('KTooltip', KTooltip)
  app.component('KDivider', KDivider)
  app.component('KQuickAccessCard', KQuickAccessCard)
  app.component('KAccordion', KAccordion)
  app.component('KStatus', KStatus)
  app.component('KRadio', KRadio)
  app.component('KDropdown', KDropdown)
  app.component('KPagination', KPagination)
  app.component('KTable', KTable)
  app.component('KTabPanel', KTabPanel)
  app.component('KTab', KTab)
  app.component('KAvatar', KAvatar)
  app.component('KBreadcrumbs', KBreadcrumbs)
  app.component('KWorkingHours', KWorkingHours)
  app.component('KToast', KToast)
  app.component('KDiscountCard', KDiscountCard)
  app.component('KCategoryCard', KCategoryCard)
  app.component('KCircleIcon', KCircleIcon)
  app.component('KColourPicker', KColourPicker)
  app.component('KDialog', KDialog)
  app.component('KUploader', KUploader)
  app.component('KCropper', KCropper)
  app.component('KMenuItem', KMenuItem)
  app.component('KItemCard', KItemCard)
  app.component('KMenuCard', KMenuCard)
  app.component('KColourCode', KColourCode)
  app.component('KIconPicker', KIconPicker)
  app.component('KKeypad', KKeypad)
  app.component('KColourLine', KColourLine)
  app.component('KColourDot', KColourDot)
  app.component('KCategoryPosCard', KCategoryPosCard)

  app.component('KCheckoutButton', KCheckoutButton)
  app.component('KBillButton', KBillButton)
  app.component('KGlassCard', KGlassCard)
  app.component('KPosButton', KPosButton)
  app.component('KItemPosCard', KItemPosCard)
  app.component('KBasicPopup', KBasicPopup)
  app.component('KFileUploader', KFileUploader)
  app.component('KMemoLine', KMemoLine)
}

export {
  install,
  KAccordion,
  KActionBtn,
  KAlert,
  KAvatar,
  KBadge,
  KBillButton,
  KBreadcrumbs,
  KBtn,
  KCallout,
  KCategoryCard,
  KCategoryPosCard,
  KCheckbox,
  KCheckoutButton,
  KCircleIcon,
  KColourCode,
  KColourLine,
  KColourDot,
  KColourPicker,
  KCounter,
  KCropper,
  KDialog,
  KDiscountCard,
  KDivider,
  KDropdown,
  KExportCsv,
  KExternalLabel,
  KGlassCard,
  KIcon,
  KIconPicker,
  KInput,
  KItemCard,
  KItemPosCard,
  KKeypad,
  KMenuCard,
  KMenuItem,
  KPagination,
  KPopup,
  KPosButton,
  KQuickAccessCard,
  KRadio,
  KRange,
  KStatus,
  KTab,
  KTabPanel,
  KToast,
  KToggle,
  KTooltip,
  KUploader,
  KWorkingHours,
  KBasicPopup,
  KFileUploader,
}
